import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Typography } from "@mui/material";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSelect from "../../../../components/Select/Select";
import {
  getClinicFacilities,
  getLocations,
  getPetBillingById,
  updateAppointmentStatusById,
  updateCaseSummaryUrlByApntId,
  updateFinalize,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../../redux/reducers/vetSlice";
import { AppColors } from "../../../../util/AppColors";
import { workbookStatusList } from "../../../../util/dropList";
import { getRightSaluation } from "../../../../util/function";
import BodyMapView from "../../../CommonScreens/WorkBook/BodyMapView";
import DiagnosticsView from "../../../CommonScreens/WorkBook/DiagnosticsView";
import FileView from "../../../CommonScreens/WorkBook/FileView";
import FormsView from "../../../CommonScreens/WorkBook/FormsView";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import PreventiveView from "../../../CommonScreens/WorkBook/PreventiveView";
import ProceduresView from "../../../CommonScreens/WorkBook/ProceduresView";
import SoapNoteView from "../../../CommonScreens/WorkBook/SoapNoteView";
import TreatmentPlanView from "../../../CommonScreens/WorkBook/TreatmentPlanView";
import VitalsView from "../../../CommonScreens/WorkBook/VitalsView";

const initOpen = {
  overview: true,
  procedures: true,
  administered: true,
  preventive: true,
  prescription: true,
  diagnostics: true,
  soapNotes: true,
  surgeryDoc: true,
  treatmentPlan: true,
  forms: true,
  vitals: true,
  bodyMap: true,
  files: true,
};

const iconSty = { width: 25, height: 25, color: AppColors.appPrimary };

const WorkBookHistory = ({
  finModVsble,
  setFinModVsble,
  handleFinalize,
  isSumamryView = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pdfRef = useRef(null);
  const [status, setStatus] = useState("Active");
  const [profileImg, setProfileImg] = useState(null);
  const [openValues, setOpenValues] = useState(initOpen);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const {
    locationList,
    clinicStocks,
    apiInProgress,
    facilities,
    details: clinicDet,
  } = useSelector((state) => state?.clinic);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const apntId = reqDet?.appointment?.appointmentId;
  const apntDet = reqDet?.appointment;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const isAnyApiInProgress =
    apiInProgress?.soapGeneration ||
    apiInProgress?.clinicNotesPost ||
    apiInProgress?.clinicNotesPut ||
    apiInProgress?.consolidateSoap;

  // AWS.config.update({
  //   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  //   secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  //   region: process.env.REACT_APP_AWS_REGION,
  // });

  // const s3 = new AWS.S3();
  // const bucketName = process.env.REACT_APP_AWS_BUGET_NAME;

  useEffect(() => {
    if (finModVsble) {
      dispatch(getPetsCompliantSummaryWoLoader(apntId));
      //for the purpose of storing stock issue list
      dispatch(getClinicVets());
      dispatch(getLocations());
      dispatch(getClinicFacilities());
    }
  }, [finModVsble]);

  useEffect(() => {
    if (clinicDet?.image) {
      fetch(clinicDet.image)
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => setProfileImg(reader.result);
        });
    }
  }, [clinicDet?.image]);

  const onCloseMod = () => {
    setFinModVsble(false);
    setOpenValues(initOpen);
  };

  const handleOpen = (name, value) => {
    setOpenValues({ ...openValues, [name]: value });
  };

  const getcompliantSummary = () => {
    dispatch(getPetsCompliantSummaryWoLoader(apntId));
  };

  // const uploadPdfToS3 = (blob, filename) => {
  //   return new Promise((resolve, reject) => {
  //     const params = {
  //       Bucket: bucketName,
  //       Key: filename,
  //       Body: blob,
  //       ContentType: "application/pdf",
  //     };
  //     s3.upload(params, (err, data) => {
  //       if (err) {
  //         console.error("Error uploading to S3:", err);
  //         reject(err);
  //       } else {
  //         resolve(data?.Location);
  //       }
  //     });
  //   });
  // };

  const getCompletedAdministerList = () => {
    return (
      reqDet?.procedures?.flatMap((li) =>
        li?.procedureDetails?.filter(
          (det) =>
            det?.type === "Administered" &&
            det?.stockId &&
            det?.batchId &&
            det?.status === "true",
        ),
      ) ?? []
    );
  };

  const getVetDepartment = () => {
    const reqDept =
      clinicVets?.find((vl) => vl?.doctorId === apntDet?.doctorId)
        ?.department ?? null;
    return reqDept;
  };

  const getProductNameByStockId = (stckId) => {
    return (
      clinicStocks?.data?.find((stc) => stc?.stockId === stckId)?.productName ??
      ""
    );
  };

  const getToLocationBasedOnVetDepartment = () => {
    return (
      locationList?.find((li) => li?.department === getVetDepartment()) ?? null
    );
  };

  const onSaveAndSubmit = async () => {
    //for the purpose of storing stock issue list if the quantity is not available

    // if (getCompletedAdministerList()?.length > 0) {
    //   const statFacility =
    //     facilities?.find((li) => li?.facilityId === apntDet?.facilityId) ??
    //     null;
    //   // {
    //   //   name: apntDet?.facility,
    //   //   primaryStorage: 63,
    //   //   secondaryStorage: 59,
    //   //   facilityId: apntDet?.facilityId,
    //   // };
    //   const issueList = [];
    //   getCompletedAdministerList()?.forEach((li) => {
    //     const batchList = clinicStocks?.data?.find(
    //       (stc) => stc?.stockId === li?.stockId
    //     )?.stockBatch;
    //     const stockAvailInPrimStore = batchList?.find(
    //       (bat) => bat?.locationId === statFacility?.primaryStorage
    //     );
    //     if (stockAvailInPrimStore) return;
    //     const stockAvailInSecStore = batchList?.find(
    //       (bat) => bat?.locationId === statFacility?.secondaryStorage
    //     );
    //     const reqObj = {
    //       itemName: li?.procedureName ?? "",
    //       quantity: Number(stockAvailInSecStore ? li?.quantity : -li?.quantity),
    //       status: "Completed",
    //       stockId: li?.stockId ?? null,
    //       batchId: stockAvailInSecStore?.batchId ?? null,
    //       mode: "auto",
    //       isRejected: false,
    //       issueQuantity: Number(
    //         stockAvailInSecStore ? li?.quantity : -li?.quantity
    //       ),
    //     };
    //     if (stockAvailInSecStore) {
    //       reqObj.fromLocationId = stockAvailInSecStore?.locationId;
    //       reqObj.fromLocationName = stockAvailInSecStore?.location;
    //       reqObj.toLocationId = statFacility?.primaryStorage;
    //       reqObj.toLocation = statFacility?.name;
    //       issueList.push(reqObj);
    //       return;
    //     }
    //     reqObj.fromLocationId = statFacility?.primaryStorage;
    //     reqObj.fromLocationName = statFacility?.name;
    //     reqObj.toLocationId = statFacility?.primaryStorage;
    //     reqObj.toLocation = statFacility?.name;
    //     issueList.push(reqObj);
    //   });
    //   if (issueList?.length > 0) {
    //     const apiObj = {
    //       facilityId: statFacility?.facilityId,
    //       stockIssueDetails: issueList,
    //       requestedDate: moment(new Date()).format("YYYY-MM-DD"),
    //       requestedBy: apntDet?.doctorId ?? null,
    //     };
    //     dispatch(createStockIssue(apiObj));
    //   }
    // }

    // if (getCompletedAdministerList()?.length > 0) {
    //   const issueList = [];
    //   getCompletedAdministerList()?.forEach((li) => {
    //     const batchList = clinicStocks?.data?.find(
    //       (stc) => stc?.stockId === li?.stockId
    //     )?.stockBatch;
    //     const vetDeptMatchList = batchList?.filter(
    //       (bl) => bl?.department === getVetDepartment()
    //     );
    //     const batchMatchWithVetDept = vetDeptMatchList?.find(
    //       (bl) => bl?.batchId === li?.batchId
    //     );
    //     if (batchMatchWithVetDept && batchMatchWithVetDept?.quantity > 0) {
    //       return;
    //     }
    //     if (batchMatchWithVetDept && !batchMatchWithVetDept?.quantity > 0) {
    //       issueList.push({
    //         ...li,
    //         ...batchMatchWithVetDept,
    //         from: "Vet Department",
    //         issue: "Quantity not available",
    //         fromLocation: batchMatchWithVetDept?.location,
    //         fromLocationId: batchMatchWithVetDept?.locationId,
    //         toLocation: getToLocationBasedOnVetDepartment()?.locationName,
    //         toLocationId: getToLocationBasedOnVetDepartment()?.id,
    //         department: getVetDepartment(),
    //       });
    //       return;
    //     }
    //     const filteredList = batchList?.filter((batch) => {
    //       const location = locationList?.find(
    //         (loc) => loc?.id === batch?.locationId
    //       );
    //       if (!location) return false;
    //       // Condition 1: Clinic
    //       if (location?.mainLocation?.includes("Clinic")) {
    //         return true;
    //       }
    //       // Condition 2: Pharmacy or Pet Shop
    //       if (
    //         location?.mainLocation?.includes("Pharmacy") ||
    //         location?.mainLocation?.includes("Pet Shop")
    //       ) {
    //         return true;
    //       }
    //       return false;
    //     });
    //     const batchMatchWithLocation = filteredList?.find(
    //       (bl) => bl?.batchId === li?.batchId
    //     );
    //     if (batchMatchWithLocation) {
    //       issueList.push({
    //         ...li,
    //         ...batchMatchWithLocation,
    //         from: "Location",
    //         issue: "Quantity available",
    //         fromLocation: batchMatchWithLocation?.location,
    //         fromLocationId: batchMatchWithLocation?.locationId,
    //         toLocation: vetDeptMatchList?.[0]?.location,
    //         toLocationId: vetDeptMatchList?.[0]?.locationId,
    //         department: vetDeptMatchList?.[0]?.department,
    //       });
    //     }
    //   });
    //   if (issueList?.length > 0) {
    //     const stockIssueDetails = issueList?.map((li) => {
    //       const reqObj = {
    //         itemName: getProductNameByStockId(li?.stockId) ?? "",
    //         quantity: 1,
    //         status: "Completed",
    //         stockId: li?.stockId ?? null,
    //         batchId: li?.batchId ?? null,
    //         mode: "auto",
    //         department: li?.department ?? null,
    //         issueQuantity: 1,
    //         fromLocationName: li?.fromLocation ?? null,
    //         fromLocationId: li?.fromLocationId ?? null,
    //         toLocationName: li?.toLocation ?? null,
    //         toLocationId: li?.toLocationId ?? null,
    //       };
    //       return reqObj;
    //     });
    //     const apiObj = {
    //       stockIssueDetails,
    //       requestedDate: moment(new Date()).format("YYYY-MM-DD"),
    //       requestedBy: apntDet?.doctorId ?? null,
    //     };
    //     dispatch(createStockIssue(apiObj));
    //   }
    // }
    handleFinalize();
    // const finRes = await handleFinalize();
    // if (!finRes) return;
    const element = pdfRef?.current;
    if (!element) return;
    let url = "";
    const fileName = `${reqDet?.appointment?.petName}-${Date.now()}.pdf`;
    const opt = {
      margin: 0.5,
      filename: fileName,
      image: { type: "jpeg", quality: 0.75 },
      html2canvas: {
        scale: 1.5,
        useCORS: true,
        logging: false,
        letterRendering: true,
      },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    try {
      const pdfBlob = await html2pdf().from(element).set(opt).outputPdf("blob");
      // url = await uploadPdfToS3(pdfBlob, fileName);
      const form = new FormData();
      // form.append("pdf", url);
      form.append("pdf", pdfBlob, fileName);
      form.append("caseStatus", status);
      dispatch(
        updateCaseSummaryUrlByApntId({
          apntId: apntDet?.appointmentId,
          form,
        }),
      );
      if (apntDet?.appointmentType === "Home") {
        dispatch(
          updateAppointmentStatusById({
            appointmentId: apntDet?.appointmentId,
            status: "finalize",
            successMsg: "Status updated successfully!",
          }),
        ).then((res) => {
          if (res?.payload) getcompliantSummary();
        });
      }
      if (apntDet?.appointmentType === "Physical") {
        dispatch(updateFinalize(apntDet?.appointmentId)).then((response) => {
          if (response?.payload) getcompliantSummary();
        });
      }
      setFinModVsble(false);
      dispatch(
        getPetBillingById({ petId: apntDet?.petId, url: `?page=1&itemSize=5` }),
      ).then((res) => {
        if (res?.payload) {
          const reqData = res?.payload?.data?.find(
            (li) => li?.appointmentId === apntDet?.appointmentId,
          );
          if (reqData) {
            navigate("/clinic-pet-details", {
              state: {
                bill: reqData,
                editBill: true,
                selectedTab: "billing",
                appointment: {
                  appoinment: {
                    appointmentId: apntDet?.appointmentId,
                    petId: apntDet?.petId,
                  },
                },
              },
            });
          }
        }
      });
    } catch (error) {
      console.log("PDF generation or upload failed:", error);
    }

    // html2pdf()
    //   .set({
    //     margin: 10,
    //     filename: "document.pdf",
    //     image: { type: "jpeg", quality: 0.98 },
    //   })
    //   .from(pdfRef.current)
    //   .save();
    // html2pdf()
    //   .from(pdfRef.current)
    //   .outputPdf("blob")
    //   .then((blob) => {});
  };

  const getReqPresList = () => {
    const unSavedWorkBook = localStorage.getItem("unSavedWorkbook");
    if (unSavedWorkBook) {
      const parsedValue = JSON.parse(unSavedWorkBook);
      if (parsedValue?.presList?.length > 0) {
        const reqData = [
          ...(reqDet?.prescription ?? []),
          {
            remark: "",
            id: Date.now(),
            i: reqDet?.prescription?.length ?? 0,
            prescriptionDetails: parsedValue?.presList,
          },
        ];
        return reqData;
      }
    }
    return reqDet?.prescription ?? [];
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${reqDet?.appointment?.petName ?? ""}_${Date.now()}`,
    removeAfterPrint: true,
  });

  return (
    <>
      <div style={{ display: "none" }}>
        <div ref={pdfRef}>
          <div className="his-bodr">
            <div className="flex-row-ali-cen mv20">
              <div className="w20Per">
                <div className="pl20">
                  <div>
                    {profileImg ? (
                      <img src={profileImg} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {profile?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w60Per flex-center">
                <div className="font-bold fs20 blue-color">Medical Record</div>
              </div>
              <div className="w20Per flex1-end">
                <div className="pr10">
                  <img
                    src={require("../../../../assets/images/png/VetInstantLogo.png")}
                    alt=""
                    className="wh50 blu-back p5"
                  />
                </div>
              </div>
            </div>
            <div className="mh20 mb20">
              <div className="flex-row-ali-cen">
                <div className="w70Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="fs14 blue-color font-bold">
                      Case ID - {reqDet?.appointment?.caseId}
                    </Typography>
                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                      {reqDet?.appointment?.serviceType}
                      {reqDet?.appointment?.serviceType === "Consultation"
                        ? ` | ${
                            Array.isArray(reqDet?.appointment?.reason)
                              ? reqDet?.appointment?.reason?.join(", ")
                              : reqDet?.appointment?.reason
                          }`
                        : ""}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="flex-row-ali-cen">
                      <img
                        src={require("../../../../assets/images/png/calen.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {moment(
                          new Date(reqDet?.appointment?.appointmentDate),
                        ).format("DD MMM YYYY")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/clock.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {reqDet?.appointment?.appointmentStartTime ??
                          moment(
                            new Date(reqDet?.appointment?.appointmentdateTime),
                          ).format("HH:mm")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/steath.png")}
                        className="img-wh20"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {getRightSaluation(
                          clinicVets,
                          reqDet?.appointment?.doctorId,
                        )}
                        {/* {reqDet?.appointment?.hospitalId ===
                        reqDet?.appointment?.doctorId
                          ? ""
                          : "Dr. "} */}
                        {reqDet?.appointment?.doctorName}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gry-hor-split mv15" />
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.conclusion?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold">
                    Overview
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      reqDet?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          reqDet?.appointment?.appointmentId,
                      )?.conclusion
                    }
                  </Typography>
                </>
              ) : null}
              {reqDet?.procedures?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Procedures
                  </Typography>
                  <div className="mt10" />
                  <ProceduresView procedures={reqDet?.procedures} />
                </>
              ) : null}
              {reqDet?.procedures?.length > 0 &&
              reqDet?.procedures
                ?.flatMap((proc) => proc?.procedureDetails || [])
                ?.filter(
                  (det) =>
                    det?.type === "Administered" && det?.status === "true",
                )?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Administered
                  </Typography>
                  <div className="mt10" />
                  <ProceduresView
                    procedures={reqDet?.procedures}
                    isAdminister
                  />
                </>
              ) : null}
              {reqDet?.prevetive?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Preventive
                  </Typography>
                  <PreventiveView preventives={reqDet?.prevetive} />
                </>
              ) : null}
              {reqDet?.diagnostics?.filter(
                (li) => li?.dueDate === reqDet?.appointment?.appointmentDate,
              )?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Diagnostics
                  </Typography>
                  <div className="mt10" />
                  <DiagnosticsView
                    diagnostics={reqDet?.diagnostics?.filter(
                      (li) =>
                        li?.dueDate === reqDet?.appointment?.appointmentDate,
                    )}
                  />
                </>
              ) : null}
              {getReqPresList()?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Prescription
                  </Typography>
                  <div className="mt10" />
                  <PrescriptionView prescriptions={getReqPresList()} />
                </>
              ) : null}
              {reqDet?.forms?.filter((li) => li?.status)?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Consent Forms
                  </Typography>
                  <FormsView
                    forms={reqDet?.forms?.filter((li) => li?.status)}
                  />
                </>
              ) : null}
              {reqDet?.vitals?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Vitals
                  </Typography>
                  <VitalsView vitals={reqDet?.vitals} />
                </>
              ) : null}
              {reqDet?.bodymaps?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Body Map
                  </Typography>
                  <BodyMapView bodyMaps={reqDet?.bodymaps} />
                </>
              ) : null}
              {reqDet?.files?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Files
                  </Typography>
                  <FileView files={reqDet?.files} />
                </>
              ) : null}
              {reqDet?.appointment?.notes?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Notes
                  </Typography>
                  <Typography className="fs12 txt-regular gray11">
                    {reqDet?.appointment?.notes}
                  </Typography>
                </>
              ) : null}
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.keyIssues?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Key Issues
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      reqDet?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          reqDet?.appointment?.appointmentId,
                      )?.keyIssues
                    }
                  </Typography>
                </>
              ) : null}
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.abnormalFindings?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Abnormal Findings
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      reqDet?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          reqDet?.appointment?.appointmentId,
                      )?.abnormalFindings
                    }
                  </Typography>
                </>
              ) : null}
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.customerInstructions?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Customer Instructions
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      reqDet?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          reqDet?.appointment?.appointmentId,
                      )?.customerInstructions
                    }
                  </Typography>
                </>
              ) : null}
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.reminders?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Reminders
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      reqDet?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          reqDet?.appointment?.appointmentId,
                      )?.reminders
                    }
                  </Typography>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        open={finModVsble}
        onClose={onCloseMod}
        header=""
        headerCenter
        headerBold
        modal
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <div className="his-bodr">
            <div className="flex-row-ali-cen mv20">
              <div className="w20Per">
                <div className="pl20">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w60Per flex-center">
                <div className="font-bold fs20 blue-color">Medical Record</div>
              </div>
              <div className="w20Per flex1-end">
                <div className="pr10">
                  <img
                    src={require("../../../../assets/images/png/VetInstantLogo.png")}
                    alt=""
                    className="wh50 blu-back p5"
                  />
                </div>
              </div>
            </div>
            <div className="mh20 mb20">
              <div className="flex-row-ali-cen">
                <div className="w70Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="fs14 blue-color font-bold">
                      Case ID - {reqDet?.appointment?.caseId}
                    </Typography>
                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                      {reqDet?.appointment?.serviceType}
                      {reqDet?.appointment?.serviceType === "Consultation"
                        ? ` | ${
                            Array.isArray(reqDet?.appointment?.reason)
                              ? reqDet?.appointment?.reason?.join(", ")
                              : reqDet?.appointment?.reason
                          }`
                        : ""}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="flex-row-ali-cen">
                      <img
                        src={require("../../../../assets/images/png/calen.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {moment(
                          new Date(reqDet?.appointment?.appointmentDate),
                        ).format("DD MMM YYYY")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/clock.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {reqDet?.appointment?.appointmentStartTime ??
                          moment(
                            new Date(reqDet?.appointment?.appointmentdateTime),
                          ).format("HH:mm")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/steath.png")}
                        className="img-wh20"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {}
                        {getRightSaluation(
                          clinicVets,
                          reqDet?.appointment?.doctorId,
                        )}
                        {/* {reqDet?.appointment?.hospitalId ===
                        reqDet?.appointment?.doctorId
                          ? ""
                          : "Dr. "} */}
                        {reqDet?.appointment?.doctorName}
                      </Typography>
                    </div>
                  </div>
                </div>
                {!isSumamryView ? (
                  <div className="w30Per">
                    <CustomSelect
                      select
                      list={workbookStatusList}
                      value={status}
                      handleChange={(e) => setStatus(e?.target?.value)}
                    />
                  </div>
                ) : null}
              </div>
              <div className="gry-hor-split mv15" />
              {reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId,
              )?.conclusion?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("overview", !openValues?.overview)
                    }
                  >
                    {openValues?.overview ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Overview
                    </Typography>
                  </div>
                  {openValues?.overview ? (
                    <Typography className="fs12 txt-regular gray11">
                      {
                        reqDet?.clinicalNotes?.find(
                          (cn) =>
                            cn?.appointmentId ===
                            reqDet?.appointment?.appointmentId,
                        )?.conclusion
                      }
                    </Typography>
                  ) : null}
                </>
              ) : null}

              {reqDet?.procedures?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("procedures", !openValues?.procedures)
                    }
                  >
                    {openValues?.procedures ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Procedures
                    </Typography>
                  </div>
                  {openValues?.procedures && (
                    <ProceduresView procedures={reqDet?.procedures} />
                  )}
                </>
              ) : null}
              {reqDet?.procedures?.length > 0 &&
              reqDet?.procedures
                ?.flatMap((proc) => proc?.procedureDetails || [])
                ?.filter(
                  (det) =>
                    det?.type === "Administered" && det?.status === "true",
                )?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("administered", !openValues?.administered)
                    }
                  >
                    {openValues?.administered ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Administered
                    </Typography>
                  </div>
                  {openValues?.administered && (
                    <ProceduresView
                      procedures={reqDet?.procedures}
                      isAdminister
                    />
                  )}
                </>
              ) : null}
              {reqDet?.prevetive?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("preventive", !openValues?.preventive)
                    }
                  >
                    {openValues?.preventive ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Preventive
                    </Typography>
                  </div>
                  {openValues?.preventive && (
                    <PreventiveView preventives={reqDet?.prevetive} />
                  )}
                </>
              ) : null}
              {reqDet?.diagnostics?.filter(
                (li) => li?.dueDate === reqDet?.appointment?.appointmentDate,
              )?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("diagnostics", !openValues?.diagnostics)
                    }
                  >
                    {openValues?.diagnostics ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Diagnostics
                    </Typography>
                  </div>
                  {openValues?.diagnostics && (
                    <DiagnosticsView
                      diagnostics={reqDet?.diagnostics?.filter(
                        (li) =>
                          li?.dueDate === reqDet?.appointment?.appointmentDate,
                      )}
                      showFileAlso
                    />
                  )}
                </>
              ) : null}
              {getReqPresList()?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("prescription", !openValues?.prescription)
                    }
                  >
                    {openValues?.prescription ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Prescription
                    </Typography>
                  </div>
                  {openValues?.prescription && (
                    <PrescriptionView prescriptions={getReqPresList()} />
                  )}
                </>
              ) : null}
              {(reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId &&
                  cn?.consolidated,
              ) ??
              reqDet?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId &&
                  !cn?.consolidated,
              )) ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("soapNotes", !openValues?.soapNotes)
                    }
                  >
                    {openValues?.soapNotes ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Soap Notes
                    </Typography>
                  </div>
                  {openValues?.soapNotes && (
                    <SoapNoteView
                      apntId={apntId}
                      soapNote={
                        reqDet?.clinicalNotes?.find(
                          (cn) =>
                            cn?.appointmentId ===
                              reqDet?.appointment?.appointmentId &&
                            cn?.consolidated,
                        ) ??
                        reqDet?.clinicalNotes?.find(
                          (cn) =>
                            cn?.appointmentId ===
                              reqDet?.appointment?.appointmentId &&
                            !cn?.consolidated,
                        )
                      }
                    />
                  )}
                </>
              ) : null}
              {(reqDet?.inpatientNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId &&
                  cn?.type === "surgery" &&
                  cn?.consolidated,
              ) ??
              reqDet?.inpatientNotes?.find(
                (cn) =>
                  cn?.appointmentId === reqDet?.appointment?.appointmentId &&
                  cn?.type === "surgery",
              )) ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("surgeryDoc", !openValues?.surgeryDoc)
                    }
                  >
                    {openValues?.surgeryDoc ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Surgery Documentation
                    </Typography>
                  </div>
                  {openValues?.surgeryDoc && (
                    <SoapNoteView
                      apntId={apntId}
                      soapNote={
                        reqDet?.inpatientNotes?.find(
                          (cn) =>
                            cn?.appointmentId ===
                              reqDet?.appointment?.appointmentId &&
                            cn?.type === "surgery" &&
                            cn?.consolidated,
                        ) ??
                        reqDet?.inpatientNotes?.find(
                          (cn) =>
                            cn?.appointmentId ===
                              reqDet?.appointment?.appointmentId &&
                            cn?.type === "surgery",
                        )
                      }
                      isSurgery
                    />
                  )}
                </>
              ) : null}
              {reqDet?.treatmentPlas?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() =>
                      handleOpen("treatmentPlan", !openValues?.treatmentPlan)
                    }
                  >
                    {openValues?.treatmentPlan ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Protocol Forms
                    </Typography>
                  </div>
                  {openValues?.treatmentPlan && (
                    <TreatmentPlanView plans={reqDet?.treatmentPlas} />
                  )}
                </>
              ) : null}
              {reqDet?.forms?.filter((li) => li?.status)?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleOpen("forms", !openValues?.forms)}
                  >
                    {openValues?.forms ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Consent Forms
                    </Typography>
                  </div>
                  {openValues?.forms && (
                    <FormsView
                      forms={reqDet?.forms?.filter((li) => li?.status)}
                    />
                  )}
                </>
              ) : null}
              {reqDet?.vitals?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleOpen("vitals", !openValues?.vitals)}
                  >
                    {openValues?.vitals ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Vitals
                    </Typography>
                  </div>
                  {openValues?.vitals && <VitalsView vitals={reqDet?.vitals} />}
                </>
              ) : null}
              {reqDet?.bodymaps?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleOpen("bodyMap", !openValues?.bodyMap)}
                  >
                    {openValues?.bodyMap ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Body Map
                    </Typography>
                  </div>
                  {openValues?.bodyMap && (
                    <BodyMapView bodyMaps={reqDet?.bodymaps} />
                  )}
                </>
              ) : null}
              {reqDet?.files?.length > 0 ? (
                <>
                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleOpen("files", !openValues?.files)}
                  >
                    {openValues?.files ? (
                      <ArrowDropDownIcon sx={iconSty} />
                    ) : (
                      <ArrowRightIcon sx={iconSty} />
                    )}
                    <Typography className="fs14 blue-color font-bold">
                      Files
                    </Typography>
                  </div>
                  {openValues?.files && <FileView files={reqDet?.files} />}
                </>
              ) : null}
              {reqDet?.appointment?.notes?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Notes
                  </Typography>
                  <Typography className="fs12 txt-regular gray11">
                    {reqDet?.appointment?.notes}
                  </Typography>
                </>
              ) : null}
            </div>
          </div>

          <div className="flex-center mt30">
            <div>
              {isSumamryView ? (
                <CustomButton
                  text="Download"
                  smallBtn
                  onClick={() => handlePrint(null, () => pdfRef?.current)}
                />
              ) : (
                <CustomButton
                  text="Save & Submit"
                  smallBtn
                  onClick={onSaveAndSubmit}
                  disabled={isAnyApiInProgress}
                  grayBtn={isAnyApiInProgress}
                />
              )}
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default WorkBookHistory;
